<template>
	<el-dialog title="修改手机号登录密码" :visible.sync="visible" width="420px" @close="close">
		<el-tabs v-model="activeTab" type="card" style="margin-bottom:15px;">
			<el-tab-pane label="原密码修改" name="oldPwd"></el-tab-pane>
			<el-tab-pane label="验证码修改" name="captcha"></el-tab-pane>
		</el-tabs>

		<el-form :model="form" label-width="80px" ref="formRef" :rules="formRules">
			<div v-if="activeTab === 'captcha'">
				<el-form-item label="验证码" prop="captcha">
					<div style="display:flex;gap:8px;align-items:center;">
						<el-input v-model="form.captcha" placeholder="请输入短信验证码"></el-input>
						<el-button :disabled="countDown > 0" @click="sendCaptcha" style="white-space:nowrap;">
							{{ countDown > 0 ? `${countDown}秒后重发` : '发送验证码' }}
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" />
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPwd">
					<el-input v-model="form.confirmPwd" type="password" placeholder="请确认新密码" />
				</el-form-item>
			</div>
			<div v-if="activeTab === 'oldPwd'">
				<el-form-item label="原密码" prop="oldPwd">
					<el-input v-model="form.oldPwd" type="password" placeholder="请输入原登录密码" />
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" />
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPwd">
					<el-input v-model="form.confirmPwd" type="password" placeholder="请确认新密码" />
				</el-form-item>
			</div>
		</el-form>

		<div slot="footer" class="dialog-footer">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="submit">确认修改</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'Password',
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},

		data() {
			// 密码强度校验
			const validatePwdRule = (rule, value, callback) => {
				const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/
				if (!reg.test(value)) {
					return callback(new Error('密码需6~16位，包含字母和数字'))
				}
				callback()
			}
			// 两次密码一致校验
			const validateSamePwd = (rule, value, callback) => {
				if (value !== this.form.newPwd) {
					return callback(new Error('两次输入密码不一致'))
				}
				callback()
			}

			return {
				// 当前切换标签 captcha/oldPwd
				activeTab: 'oldPwd',
				form: {
					oldPwd: '',
					newPwd: '',
					confirmPwd: '',
					captcha: ''
				},
				countDown: 0,
				timer: null,
				login: null,
				// 全局表单校验规则
				formRules: {
					captcha: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							len: 6,
							message: '验证码为6位数字',
							trigger: 'blur'
						}
					],
					oldPwd: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					newPwd: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							validator: validatePwdRule,
							trigger: 'blur'
						}
					],
					confirmPwd: [{
							required: true,
							message: '请再次输入新密码',
							trigger: 'blur'
						},
						{
							validator: validateSamePwd,
							trigger: 'blur'
						}
					]
				}
			}
		},
		computed: {
			visible: {
				get() {
					return this.show
				},
				set(val) {
					this.$emit('update:show', val)
				}
			}
		},
		watch: {
			// 切换标签清空校验提示
			activeTab() {
				this.$nextTick(() => {
					this.$refs.formRef.clearValidate()
				})
			}
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			// 关闭弹窗重置全部数据
			close() {
				this.$emit('update:show', false)
				this.activeTab = 'oldPwd'
				this.form = {
					oldPwd: '',
					newPwd: '',
					confirmPwd: '',
					captcha: '',
				}
				this.$nextTick(() => {
					this.$refs.formRef.clearValidate()
				})
				if (this.timer) {
					clearInterval(this.timer)
					this.countDown = 0
					this.timer = null
				}
			},
			async sendCaptcha() {
				try {
					const res = await this.API.post(this.API.fileurl.postSendCaptcha)
					if (res.status == 200) {
						this.$message.success('验证码已发送，有效期3分钟')
						this.countDown = 180
						this.timer = setInterval(() => {
							this.countDown--
							if (this.countDown <= 0) {
								clearInterval(this.timer)
								this.timer = null
							}
						}, 1000)
					} else {
						this.$message.error(res.msg)
					}
				} catch (err) {
					this.$message.error('发送失败，请稍后重试')
				}
			},
			submit() {
				this.$refs.formRef.validate(async (valid) => {
					if (!valid) return
					this.loginOpen('修改中...')
					try {
						let res
						if (this.activeTab === 'captcha') {
							res = await this.API.post(this.API.fileurl.postCaptchaPwd, {
								captcha: this.form.captcha,
								newPwd: this.form.newPwd,
							})
						} else {
							res = await this.API.post(this.API.fileurl.postPhoneUpdatePwd, {
								oldPwd: this.form.oldPwd,
								newPwd: this.form.newPwd
							})
						}
						if (res.status == 200) {
							this.$message.success('手机登陆密码修改成功')
							this.subType()
						} else {
							this.$message.error(res.msg || '修改失败')
						}
					} catch (err) {
						this.$message.error('请求异常，修改失败')
					} finally {
						this.noLogin()
					}
				})
			},
			subType() {
				this.$emit('phonePwd', 'false')
				this.close()
			},
		},
		beforeDestroy() {
			if (this.timer) clearInterval(this.timer)
		}
	}
</script>

<style scoped>
	.dialog-footer {
		text-align: right;
	}
</style>